<template>
  <div>
    <label class="input-label" :class="{'light': light}" :title="title">
      {{label}}
      <input class="input-text" type="checkbox" v-model="localValue">
      <div class="input-help" v-html="help" v-if="help"></div>
    </label>
  </div>

</template>

<script>
export default {
  name: 'InputCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    localValue: {
      get () {
        return this.value || null;
      },
      set (v) {
        this.$emit('input', v);
      }
    }
  }
};
</script>

<style>
.light {
  font-weight: normal;
  font-size: 1.4rem;
}

.input-text {
  cursor: pointer;
}
</style>
